import React from 'react';
import {Modal} from '@material-ui/core';
import ButtonInput from '../ButtonInput'
import './AlertModal.scss';

const AlertModal = ({isOpen, text, onClose, type = null}) => (
    <Modal
        open={isOpen}
        onClose={() => onClose()}
    >
        <div className={`modal-access-denied ${type !== null ? type : 'primary'}-label`}>
            <div className="fields-row m-b-20 body-title">{text}</div>

            <div className="fields-row actions-modal">
                <ButtonInput className='dark-button transparent-btn-black'
                             title='Ok'
                             width='122'
                             size='middle'
                             handleClick={() => onClose()}/>
            </div>
        </div>
    </Modal>
);

export default AlertModal;


// WEBPACK FOOTER //
// ./src/components/Common/AlertModal/AlertModal.js